<template>
    <!-- 多币种结算与智能换汇  -->
    <main-page :title="title" :subtitle="subtitle" :description="description" :button-text="buttonText" :bg="bg" />
</template>

<script>
import MainPage from "./components/MainPage.vue";

export default {
    name: 'currency',
    components: {
        MainPage
    },
    data() {
        return {
            bg: "/img/pay/0--34.png",
        }
    },
    computed: {
        title() {
            return this.$t('currency.title');
        },
        subtitle() {
            return this.$t('currency.subtitle');
        },
        description() {
            return this.$t('currency.description');
        },
        buttonText() {
            return this.$t('common.buttonText');
        },
    }

}
</script>
